const breakpoints = {
  medium: 768,
  large: 1024,
};

const initialState = {
  isScrolling: false,
  multiplier: 0.1,
};

class ParallaxScroll {
  constructor() {
    this.state = initialState;
    this.elements = Array.from(document.querySelectorAll('.js-parallax'));

    // Force bind to this, because we don't want to change context
    // when running in contextfull functions, like window.addEventListener()
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  init() {
    this.addCSSClasses();
    this.listenToResize();
    this.scrollLoop();
  }

  addCSSClasses() {
    this.elements.forEach(element => {
      element.classList.add('is-parallaxing');
    });
  }

  listenToResize() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize, false);
  }

  handleResize() {
    if (window.innerWidth < breakpoints.large) {
      this.disposeScroll();
    } else {
      this.listenToScroll();
    }
  }

  listenToScroll() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll, false);
  }

  disposeScroll() {
    window.removeEventListener('scroll', this.handleScroll, false);
  }

  handleScroll() {
    this.setState({ isScrolling: true });
  }

  scrollLoop() {
    if (this.state.isScrolling) {
      this.setState({
        isScrolling: false,
      });

      this.elements.forEach(this.adjustElementTransform.bind(this));
    }

    window.requestAnimationFrame(this.scrollLoop.bind(this));
  }

  adjustElementTransform(element) {
    const transform = this.calculateTransform(element, this.state.multiplier);

    element.style.transform = `translate3d(0, ${-transform}%, 0)`;
  }

  calculateTransform(element, multiplier) {
    const drag = Number(element.getAttribute('data-parallax-drag')) || 1;

    const positionRelativeToViewport =
      (window.innerHeight - element.getBoundingClientRect().top) / window.innerHeight;

    return positionRelativeToViewport * 100 * multiplier / drag;
  }

  setState(newState) {
    this.state = Object.assign({}, this.state, newState);
  }
}

export default ParallaxScroll;
